import { ReactElement, Ref } from "react";
import classNames from "classnames";
import { Anchor } from "client/Components";
import {
	FontIconName,
	Icon,
	SvgIconValue
} from "../../../../../Components/Icon/Icon";
import { UnreadCounter } from "../UnreadCounter/UnreadCounter";
import { setTrackingId } from "client/Misc/utils";
import styles from "./MenuItem.module.less";
import { WorkspaceHeaderStyle } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";

export type MenuItemProps = {
	icon: FontIconName | SvgIconValue;
	isActive: boolean;
	headerStyle: WorkspaceHeaderStyle;
	onClick: () => void;
	isHidden?: boolean;
	count?: number;
	trackingId?: string;
	ref?: Ref<HTMLLIElement>;
};

export const MenuItem = (props: MenuItemProps): ReactElement => {
	const {
		count = 0,
		icon,
		isActive,
		isHidden,
		onClick,
		trackingId,
		headerStyle,
		ref
	} = props;

	return (
		<li
			ref={ref}
			{...setTrackingId(trackingId)}
			className={classNames(
				styles.root,
				{
					[styles.root_active]: isActive,
					[styles.root_hidden]: isHidden,
					[styles.root_coloredHeader]: headerStyle === WorkspaceHeaderStyle.ColoredBackground
				}
			)}
		>
			<Anchor
				trackingId="link"
				className={styles.link}
				onClick={() => onClick()}
			>
				<div className={styles.container}>
					{count > 0 && (
						<div className={styles.counter}>
							<UnreadCounter count={count} />
						</div>
					)}
					<Icon value={icon} />
				</div>
			</Anchor>
		</li>
	);
};

MenuItem.displayName = "MenuItem";